export default __webpack_public_path__ + "static/media/category-tag.810a0cc3.png";